import { AlarmSummaryCategory } from '../api/models'

const alarmSummaryCategoryDisplayNames: Record<AlarmSummaryCategory, string> = {
  [AlarmSummaryCategory.Unknown]: 'Unknown',
  [AlarmSummaryCategory.Test]: 'Test',
  [AlarmSummaryCategory.CarbonMonoxide]: 'Carbon Monoxide',
  [AlarmSummaryCategory.Fire]: 'Fire',
  [AlarmSummaryCategory.Medical]: 'Medical',
  [AlarmSummaryCategory.Duress]: 'Duress',
  [AlarmSummaryCategory.Panic]: 'Panic',
  [AlarmSummaryCategory.Burglary]: 'Burglary',
  [AlarmSummaryCategory.Water]: 'Water',
  [AlarmSummaryCategory.Temperature]: 'Temperature',
  [AlarmSummaryCategory.Alert]: 'Alert',
  [AlarmSummaryCategory.OutdoorConfirmedBurglary]: 'Outdoor Confirmed Burglary',
  [AlarmSummaryCategory.OutdoorPossibleBurglary]: 'Outdoor Possible Burglary',
  [AlarmSummaryCategory.OutdoorConfirmedFire]: 'Outdoor Confirmed Fire',
  [AlarmSummaryCategory.OutdoorPossibleFire]: 'Outdoor Possible Fire',
  [AlarmSummaryCategory.OutdoorConfirmedMedical]: 'Outdoor Confirmed Medical'
}

export function getAlarmSummaryCategoryDisplayName(category: AlarmSummaryCategory | undefined): string {
  return category ? alarmSummaryCategoryDisplayNames[category] : ''
}
